<template>
    <section :id="`element-${settings.id}`" class="elle-reviews padd-v" :style="{ backgroundColor: settings?.color }">
        <div class="container">
            <UiHeadline
                :style="'center'"
                :settings="{
                    label: settings?.label,
                    headline: settings?.headline
                }"
            >
                <template #additional>
                    <UiRate
                        v-show="settings?.statistics"
                        :rating="{ ratingAmount: settings_[0]?.ratingAmount, reviewsAmount: settings_[0]?.reviewsAmount }"
                    />
                </template>
            </UiHeadline>

            <div v-if="!!settings?.reviewItems.length" class="elle-reviews-wrapper">
                <div v-show="isDesktop" class="grid12">
                    <CardsReview v-for="item in settings?.reviewItems" :key="item.id" :quote="item" />
                </div>

                <UiSliderMobile v-show="!isDesktop">
                    <template #sliders>
                        <swiper-slide v-for="item in settings?.reviewItems" :key="item.id" class="swiper-slide">
                            <CardsReview :quote="item" />
                        </swiper-slide>
                    </template>
                </UiSliderMobile>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
import type { CmsItem } from '~/types/cms';

const props = withDefaults(
    defineProps<{
        settings?: CmsItem;
    }>(),
    {
        settings: () => ({})
    }
);

const settings = computed(() => props.settings);
const isDesktop = useMediaQuery('(min-width: 768px)');
const settingsData = useSettingsData();
const settings_ = computed<CmsItem[]>(() => settingsData.value.filter(item => item.siteId == useSiteId()));
</script>
